import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsOptional } from 'class-validator';
import { Types } from 'mongoose';

import { ToObjectId } from '../decorators';
import { IsObjectId, IsValidDate } from '../validators';

export class InfoInputModel {
  @ApiProperty({ type: String, format: 'bson' })
  @IsObjectId()
  @ToObjectId()
  public id!: Types.ObjectId;

  @ApiPropertyOptional()
  @IsOptional()
  @IsValidDate()
  @Type(() => Date)
  public timestamp?: Date;
}
